var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Notes *"
    }
  }, [_c('wysiwyg', {
    model: {
      value: _vm.formComment.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.formComment, "comment", $$v);
      },
      expression: "formComment.comment"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Attachment"
    }
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "Choose a file"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File Capacity * : "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("2 MB / File")])], 1)], 1)], 1), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary w-100",
    attrs: {
      "disabled": !_vm.formComment.comment,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.formComment.comment = '';
      }
    }
  }, [_vm._v("Cancel")])]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "disabled": !_vm.formComment.comment,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.saveComment();
      }
    }
  }, [_vm._v("Submit Comment")])])], 1), _c('div', {
    staticClass: "overflow-auto d-flex w-100",
    staticStyle: {
      "max-height": "400px"
    }
  }, [_vm.maintenanceDetailData.comments.length > 0 ? _c('b-row', _vm._l(_vm.maintenanceDetailData.comments, function (comment, commentIndex) {
    return _c('b-col', {
      key: commentIndex,
      staticClass: "mb-4",
      attrs: {
        "md": "12"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('span', {
      staticClass: "text-primary"
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" " + _vm._s(_vm.moment(comment.createdAt).format('DD MMMM YYYY HH:mm')))]), _c('strong', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(comment.name))]), _c('span', [_vm._v(_vm._s(comment.comment))])]), _c('div', {
      staticClass: "border my-2 w-100"
    })]);
  }), 1) : _c('span', {
    staticClass: "text-muted text-center"
  }, [_vm._v("Tidak ada komentar.")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }